import dayjs from 'dayjs'
import timezone from 'dayjs/plugin/timezone'
import utc from 'dayjs/plugin/utc'

import { HOUR_MINUTES_FORMAT, YEAR_MONTH_DAY_FORMAT } from '~/constants'
import { OUTREACH_TIME_ASAP_VALUE } from '~/features/campaigns/utils/constants'

dayjs.extend(utc)
dayjs.extend(timezone)

export const changeDateToToday = (date: string) => {
  if (!date) return dayjs()

  const timePart = date.split('T')[1]
  const todayDate = dayjs().format(YEAR_MONTH_DAY_FORMAT)
  const todayUtc = `${todayDate}T${timePart}`

  return todayUtc
}

const ASAP_LABEL = 'As soon as possible'

export const getParsedOfuOutreachTime = (params: {
  agentTimezone?: string
  defaultValue?: string
  ofuOutreachTime?: string
  timeFormat?: string
}) => {
  const {
    defaultValue = OUTREACH_TIME_ASAP_VALUE,
    ofuOutreachTime,
    timeFormat = HOUR_MINUTES_FORMAT,
  } = params

  return ofuOutreachTime
    ? dayjs.utc(changeDateToToday(ofuOutreachTime)).format(timeFormat)
    : defaultValue
}

export const getTimeOfFirstOutreach = (
  value: string | undefined,
  agentTimezone: string | undefined,
  timeFormat: string = HOUR_MINUTES_FORMAT,
) => {
  if (!value || value === OUTREACH_TIME_ASAP_VALUE) return ASAP_LABEL

  return getParsedOfuOutreachTime({
    agentTimezone,
    ofuOutreachTime: value,
    timeFormat,
  })
}
